import { ApiError } from '../errors/api-error.js';

export class ReportRunsService {
    constructor(api) { this.api = api; }

    async count(input) {
        try {
            const response = await this.api.count(input);
            return {
                success: response.success ?? true,
                data: response.data ?? response,
                message: response.message,
            };
        } catch (error) {
            throw error instanceof ApiError ? error : new ApiError(error.message || 'Report count failed');
        }
    }

    async run(input) {
        try {
            const response = await this.api.run(input);
            return {
                success: response.success ?? true,
                data: response.data ?? response,
                message: response.message,
            };
        } catch (error) {
            throw error instanceof ApiError ? error : new ApiError(error.message || 'Report run failed');
        }
    }
}
